import api from "./interceptor";
import * as config from "./../config/config";

/**
 * 🔹 Liste complète des clients
 */
export async function get_ListeClients() {
  try {
    const response = await api.get(config.REACT_APP_ENDPOINT_LIST_CLIENTS);
    return response.data;
  } catch (error) {
    throw error;
  }
}

/**
 * 🔹 Détails d’un client
 */
export async function get_ClientById(id) {
  try {
    const response = await api.get(`${config.REACT_APP_ENDPOINT_CLIENTS}/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

/**
 * 🔹 Création d’un client
 */
export async function create_Client(data) {
  try {
    const response = await api.post(config.REACT_APP_ENDPOINT_CLIENTS, data);
    return response.data;
  } catch (error) {
    throw error;
  }
}

/**
 * 🔹 Mise à jour d’un client
 */
export async function update_Client(id, data) {
  try {
    const response = await api.put(`${config.REACT_APP_ENDPOINT_UPDATE_CLIENTS}/${id}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
}

/**
 * 🔹 Suppression d’un client
 */
export async function delete_Client(id) {
  try {
    const response = await api.delete(`${config.REACT_APP_ENDPOINT_CLIENTS}/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}
